<template>
  <div>
    <b-form-group   label-align="left" label-size="sm" :label-cols-sm="field.labelCol" :label="field.label" class="mb-0">
      <b-form-select
        @change="onChange()"
        v-model="fieldsData[field.key]"
        v-if="field.field == 'list'"
        :options="options"
        size="sm"
        align-h="start"
      ></b-form-select>

      <vue-monthly-picker
        @selected="onDateChange()"
        v-if="field.field === 'month'"
        dateFormat="YYYY-MM"
        v-model="fieldsData[field.key]"
      ></vue-monthly-picker>

      <b-form-checkbox
      text-left
        name="checkbox-1"
        v-model="fieldsData[field.key]"
        v-if="field.field === 'checkbox'"
        @input="onChkboxInput()"
        size="lg"
      ></b-form-checkbox>

      <b-form-datepicker
      text-left
        dark="false"
        v-model="fieldsData[field.key]"
        v-if="field.field === 'date'"
        @input="onChange()"
        autocomplete="off"
        menu-class="dropdown-menu"
        local="es"
        start-weekday="1"
        class="primary"
      ></b-form-datepicker>

      <b-form-radio-group
       text-left
        plain
        :required="field.required"
        v-model="fieldsData[field.key]"
        :options="field.options"
        @input="onChkboxInput()"
        v-if="field.field == 'radioGroup'"
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import { BFormDatepicker } from "bootstrap-vue";
import VueMonthlyPicker from "vue-monthly-picker";
import moment from "moment";

export default {
  component: { BFormDatepicker, VueMonthlyPicker },
  props: {
    field: {
      type: Object,
      required: true,
    },
    parentKey: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      fieldsData: {},
      type: "",
      options: [],
      month: "false",
    };
  },

  watch: {
    // whenever question changes, this function will run
    parentKey: function (newparentKey) {
      if (this.field.parentKey != "" && this.field.field == "list") {
        console.log("this.field.parentKey=" + this.field.parentKey);
        console.log("this.field.newparentKey=" + JSON.stringify(newparentKey));
        if (this.field.parentKey == newparentKey.key) {
          console.log("this.field.parentKey=" + newparentKey);
          this.onFilterUpdate(newparentKey);
        }
      }
    },
  },

  computed: {
    // a computed getter
    formatMonth: function () {
      // `this` points to the vm instance
      return moment(this.fieldsData[this.field.key]).format("YYYY-MM");
    },
  },

  mounted() {
    if (this.field.field == "list") {
      this.initAllValue();
    } else if (this.field.field == "month") {
      this.$set(this.fieldsData, this.field.key, moment().format("YYYY-MM"));
      this.onChange();
    } else if (this.field.field == "date") {
      console.log(this.field.defaultValue);
      this.$set(this.fieldsData, this.field.key, this.field.defaultValue);
      this.onChange();
    } else if (this.field.field == "checkbox") {
      this.$set(this.fieldsData, this.field.key, this.field.defaultValue);
      this.onChange();
    }
    else if (this.field.field == "radioGroup") {
      this.$set(this.fieldsData, this.field.key, this.field.defaultValue);
      this.onChange();
    }
  },

  methods: {
    onFilterUpdate(newValue) {
      this.resetValue(newValue);
    },

    initAllValue() {
      var filterOptions = JSON.parse(JSON.stringify(this.field.list));
      if (this.field.parentKey != "") {
        filterOptions = filterOptions.map((f) => {
          return {
            text: f.text,
            value: f.value.id,
          };
        });
      }
      this.fillOptionData(filterOptions);
    },

    resetValue(parent) {
      console.log("parent.value", parent.value);

      if (parent.value == null) {
        console.log("parent.value");
        this.initAllValue();
        return;
      }

      var filterOptions = this.field.list
        .filter((f) => f.value[parent.key] === parent.value)
        .map((f) => {
          return {
            text: f.text,
            value: f.value.id,
          };
        });
      /**
       * @Assign filter value to Option
       */
      this.fillOptionData(filterOptions);
      /**
       * Assign default values to text @All =''
       */
    },

    fillOptionData(filterOptions) {
      this.options = [{ value: null, text: this.$t("all") }];
      this.options.push(...filterOptions);
      this.fieldsData[this.field.key] = this.field.defaultId;
      // console.log("------------------"+JSON.stringify(this.fieldsData));
      //  console.log("fillOptionData", this.options.length);

      this.$emit(
        "filter-change",

        {
          key: this.field.key,
          value: this.fieldsData[this.field.key],
          parentKey: this.field.parentKey,
        }
      );
    },

    onDateChange() {
      //  console.log(e);
      this.$set(this.fieldsData, this.field.key, this.formatMonth);
      // this.fieldsData.splice(this.fieldsData.indexOf(this.field.key), 1, this.formatMonth)
      // this.fieldsData[this.field.key]=this.formatMonth;
      console.log(this.fieldsData[this.field.key]);

      this.$emit("filter-change", {
        key: this.field.key,
        value: this.fieldsData[this.field.key],
        parentKey: this.field.parentKey,
      });
    },

    onCheckBoxChange(e) {
      console.log("onCheckBoxChange" + e);
      this.$emit(
        "filter-change",

        {
          key: this.field.key,
          value: this.fieldsData[this.field.key],
          parentKey: this.field.parentKey,
        }
      );
    },

    onChkboxInput() {
      this.$emit(
        "filter-change",

        {
          key: this.field.key,
          value: this.fieldsData[this.field.key],
          parentKey: this.field.parentKey,
        }
      );
    },

    onChange() {
      this.$emit(
        "filter-change",

        {
          key: this.field.key,
          value: this.fieldsData[this.field.key],
          parentKey: this.field.parentKey,
        }
      );
    },
  },
};
</script>

<style scoped>
</style>